


















































































































































































































































































































































































import { Vue, Component, Prop, Watch, Ref, PropSync } from 'vue-property-decorator'
import { FormPontoDeVenda } from '@/models'
import type { FechamentoDeCaixa, FormaDePagamento, Loja, TurnoDeVenda } from '@/models'
import type { PontoDeVenda } from '@/models'
import { obrigatorio } from '@/shareds/regras-de-form'
import SeletorDeSerieFiscal from './SeletorDeSerieFiscal.vue'
import StatusDoPontoDeVenda from './StatusDoPontoDeVenda.vue'
import { SerieFiscal } from '@/models/SerieFiscal'
import { dateTimeToPtBrFormat } from '@/shareds/date/date-utils'
import { verificarSerieFiscalSemPontoDeVendaAssociado } from '@/shareds/loja-shareds'
import { EditarPdvUseCase, FecharCaixaUseCase } from '@/usecases'
import type { PagamentoServiceAdapter } from '@/usecases'
import AlertModule from '@/store/vuex/aplicacao/AlertModule'
import Confirmacao from '@/components/ui/Confirmacao.vue'
import DialogoMenuAdministrativoSitef from './DialogoMenuAdministrativoSitef.vue'
import { Inject } from 'inversify-props'
import UserLoginStore from '@/store/vuex/authentication/UserLoginStore'
import SeletorDeTabelaDePreco from '../tabeladepreco/SeletorDeTabelaDePreco.vue'

@Component({
	components: {
		SeletorDeSerieFiscal,
		StatusDoPontoDeVenda,
		Confirmacao,
		DialogoMenuAdministrativoSitef,
		SeletorDeTabelaDePreco,
	},
})
export default class DialogoDePontoDeVenda extends Vue {
	@Ref() form!: HTMLFormElement
	@Ref() campoDeNome!: HTMLInputElement
	@Ref() confirmacaoDeDescartarVenda!: Confirmacao
	@Ref() confirmacaoDeEncerrarTurno!: Confirmacao
	@Prop({ type: Object, default: criarPontoDeVenda }) initialValue!: PontoDeVenda
	@Prop({ type: Boolean, default: false }) disabled!: boolean
	@Prop({ type: Boolean, default: false }) readonly!: boolean
	@PropSync('loja', { type: Object }) lojaSync?: Loja
	@Ref() dialogoMenuAdministrativoSitef!: DialogoMenuAdministrativoSitef
	
	mostra = false
	pontoDeVenda: FormPontoDeVenda = criarPontoDeVenda()
	obrigatorio = obrigatorio
	dateTimeToPtBrFormat = dateTimeToPtBrFormat

	editarPdvUseCase = new EditarPdvUseCase()
	fecharCaixaUseCase = new FecharCaixaUseCase()
	turnoDeVenda: TurnoDeVenda[] = []

	@Inject('PagamentoServiceAdapter')
	private pagamentoService!: PagamentoServiceAdapter

	contadorMenuTef = 0
	executandoMenuSitef = false
	transacaoIdMenuSitef = ""
	readonly POLL_INTERVAL_MS = 5000
	readonly POLL_LIMITE_TENTATIVAS = 150 
	pollTentativasMenuTef = 0
	private timerMenuTef: number | null = null;
	ultimoMenuIdProcessado: string | null = null

	get verificarSerieFiscalSemPontoDeVendaAssociado() {
		return verificarSerieFiscalSemPontoDeVendaAssociado(this.pdvsSemAtual)
	}

	get pdvsSemAtual() {
		return this.lojaSync?.pdvs.filter(
			(pdv) => pdv.id !== this.pontoDeVenda.id,
		) || []
	}

	get integracaoControlPayAtiva() {
		return this.lojaSync ? this.lojaSync.configuracaoDaLoja.integracaoControlPayAtiva : false
	}

	async abrirFecharCaixa() {
		try {
			this.pontoDeVenda.aberto ? this.confirmacaoDeEncerrarTurno.mostrar() : this.pontoDeVenda = await this.editarPdvUseCase.editarSituacaoPdv(this.pontoDeVenda.id, !this.pontoDeVenda.aberto, false)
			this.initialValue.aberto = this.pontoDeVenda.aberto
		} catch (e) {
			AlertModule.setError(e)
		}
	}

	@Watch('mostra')
	onChangeMostra(mostra: boolean) {
		if (!mostra) return
		this.pontoDeVenda = JSON.parse(JSON.stringify(this.initialValue))
		setTimeout(() => {
			this.form.resetValidation()
			setTimeout(() => {
				this.campoDeNome.focus()
			})
		})
	}

	@Watch('pontoDeVenda.exigeVendedor')
	onChangeExigeVendedor() {
		if (!this.pontoDeVenda.exigeVendedor) {
			this.pontoDeVenda.obrigaInformarVendedor = false
			this.pontoDeVenda.autoPreencherVendedor = false
		}
	}

	confirmar() {
		if (!this.form.validate()) return
		this.$emit('confirma', this.pontoDeVenda)
		this.mostra = false
	}

	inserirSerieFiscal(serieFiscal: SerieFiscal) {
		if (this.lojaSync) {
			this.lojaSync = {
				...this.lojaSync,
				seriesFiscais: [
					...this.lojaSync.seriesFiscais,
					serieFiscal,
				],
			}
		}
		this.pontoDeVenda = {
			...this.pontoDeVenda,
			serieFiscal,
		}
	}

	@Watch("pontoDeVenda.podeGerarOrcamento")
	atualizarConfigDePedido() {
		if (!this.pontoDeVenda.podeGerarOrcamento) {
			this.pontoDeVenda.criaPedidoNaVenda = false
		}
	}

	@Watch("pontoDeVenda.criaPedidoNaVenda")
	atualizarConfigDaCriaPedidoNaVenda() {
		if (this.pontoDeVenda.criaPedidoNaVenda) {
			this.pontoDeVenda.vendaForaDoEstabelecimento = false
		}
	}

	@Watch("pontoDeVenda.vendaForaDoEstabelecimento")
	atualizarConfigDaVendaForaDoEstabelecimento() {
		if (this.pontoDeVenda.vendaForaDoEstabelecimento) {
			this.pontoDeVenda.criaPedidoNaVenda = false
		}
	}

	@Watch("pontoDeVenda.podeGerarOrcamento")
	onChangePodeGerarOrcamento() {
		if (this.pontoDeVenda.podeGerarOrcamento) {
			this.pontoDeVenda.criaPedidoNaVenda = false
		}
	}

	async encerrarTurnoDeVenda(encerrarTurnoDeVenda: boolean, fechamento?: FechamentoDeCaixa){
		try {
			if(encerrarTurnoDeVenda){
				const turnoDeVenda = await this.fecharCaixaUseCase.findTurnoDeVenda(this.pontoDeVenda.id)
				if(!turnoDeVenda.id) return

				fechamento = {...turnoDeVenda.fechamento,
					dataHoraFechamento: new Date(),
					turnoDeVenda: turnoDeVenda,
					anexos: [],
				}

				await this.fecharCaixaUseCase.execute(turnoDeVenda.id, fechamento)
			}

			this.initialValue.aberto = this.pontoDeVenda.aberto
			this.pontoDeVenda = await this.editarPdvUseCase.editarSituacaoPdv(this.pontoDeVenda.id, !this.pontoDeVenda.aberto, encerrarTurnoDeVenda)

		} catch (e) {
			AlertModule.setError(e)
		}
	}

	get integracaoSitefAtiva() {
		return this.lojaSync ? this.lojaSync.configuracaoDaLoja.integracaoSitefAtiva : false
	}

	created() {
		document.addEventListener('keydown', this.atalhoDeCancelarTransacaoSitef)
	}

	destroyed() {
		document.removeEventListener('keydown', this.atalhoDeCancelarTransacaoSitef)
	}

	async atalhoDeCancelarTransacaoSitef(event: KeyboardEvent) {
		if (!this.mostra) return
		if (!event.altKey || event.key.toLowerCase() !== 'ç') return
		if (!this.executandoMenuSitef || !this.pontoDeVenda) return

		event.preventDefault()
		event.stopImmediatePropagation()
		await this.pagamentoService.cancelarTransacaoSitefAtual(this.pontoDeVenda.id, true)
	}

	async abrirMenuAdministrativoSitef() {
		if (!this.permiteAbrirMenuAdministrativoSitef || !this.pontoDeVenda) return
		if (!this.executandoMenuSitef) {
			this.executandoMenuSitef = true
			this.contadorMenuTef = 0
			this.pollTentativasMenuTef = 0
			this.transacaoIdMenuSitef = ""
			this.ultimoMenuIdProcessado = null
		}
	
	
		this.timerMenuTef = window.setTimeout(async () => {
			if (!this.executandoMenuSitef) return

			try {
				this.contadorMenuTef++
				this.pollTentativasMenuTef++

				if (this.pollTentativasMenuTef > this.POLL_LIMITE_TENTATIVAS) {
					this.resetarMenuAdministrativoSitef()
					AlertModule.setWarning('Tempo esgotado aguardando menus do SiTef.')
					return
				}

				if (this.contadorMenuTef === 1) {
					const transacaoId = await this.pagamentoService.iniciarMenuAdministrativoSitef(this.pontoDeVenda.id)
					this.transacaoIdMenuSitef = transacaoId
				}

				if (!this.transacaoIdMenuSitef) throw new Error('Transação do menu SITEF não iniciada')

				let menuAdministrativo: any = null
				try {
					menuAdministrativo = await this.pagamentoService.buscarRetornoMenuAdministrativoSitef(this.transacaoIdMenuSitef)
				// eslint-disable-next-line no-empty
				} catch (_) {
				}

				if (menuAdministrativo?.id) {
					const mudouId = this.ultimoMenuIdProcessado !== menuAdministrativo.id

					if (mudouId) {
						if (!this.dialogoMenuAdministrativoSitef.mostra) {
							this.dialogoMenuAdministrativoSitef.mostrar(menuAdministrativo, this.transacaoIdMenuSitef, this.pontoDeVenda.id)
						} else {
							this.dialogoMenuAdministrativoSitef.atualizar(menuAdministrativo, this.pontoDeVenda.id)
						}
						this.ultimoMenuIdProcessado = menuAdministrativo.id
					}
				}

			// eslint-disable-next-line no-empty
			} catch (_) {
			} finally {
				if (this.executandoMenuSitef) {
					this.abrirMenuAdministrativoSitef()
				}
			}
		}, this.POLL_INTERVAL_MS)
	}

	resetarMenuAdministrativoSitef(){
		this.contadorMenuTef = 0
		this.executandoMenuSitef = false
		this.transacaoIdMenuSitef = ""
		if (this.timerMenuTef !== null) {
			clearTimeout(this.timerMenuTef)
			this.timerMenuTef = null
		}
		this.ultimoMenuIdProcessado = null
	}

	async onCancelarMenuAdministrativoSitef(transacaoId: string) {
		try {
			if (transacaoId) {
				await this.pagamentoService.finalizarMenuAdministrativoSitef(transacaoId)
			}
		} catch (e) {
			AlertModule.setError(e)
		} finally {
			this.executandoMenuSitef = false
			this.resetarMenuAdministrativoSitef()
		}
	}

	get permiteAbrirMenuAdministrativoSitef(){
		return UserLoginStore.permiteRegraDeNegocio('permite-menu-administrativo-sitef')
	}
	opcoesDeFormaDePagamento: FormaDePagamento[] = [
		'Cartão', 
		'Dinheiro', 
		'Voucher', 
		'Crediário', 
		'TEF Crédito', 
		'TEF Débito', 
		'TEF Pix', 
		'Consignado', 
		'Demonstração', 
		'Link', 
		'Brinde', 
		'Pix', 
		'Outros', 
		'Vale Presente',
		'Cheque',
	]
}

function criarPontoDeVenda(): FormPontoDeVenda {
	return {
		id: '',
		identificador: '',
		nome: '',
		valorEmCaixa: 0,
		aberto: false,
		ativo: true,
		exigeCliente: false,
		obrigaInformarVendedor: false,
		exigeVendedor: false,
		autoPreencherVendedor: false,
		parametrosFiscais: null,
		isHomologacao: false,
		serieFiscal: null,
		criaPedidoNaVenda: false,
		imprimeReciboNoOrcamento: true,
		agrupaProdutosNaVenda: false,
		imprimeComprovanteDoFechamento: true,
		idTerminalControlPay: '',
		createdAt: '',
		permiteSelecaoDeProduto: false,
		habilitarLeitor: false,
		enviarNotaPorEmail: false,
		buscarProdutoNoCaixa: false,
		podeGerarNFCE: false,
		podeGerarNFE: false,
		podeGerarOrcamento: false,
		vendaForaDoEstabelecimento: false,
		exigeModalidade: false,
		exigeClienteCadastrado: false,
		naoMovimentaEstoque: false,
		autoEnviarWhatsapp: false,
		operador: null,
		somenteDemonstracaoEConsignado: false,
		idTerminalDoPdvSitef: '',
		sequencialSitef: 0,
		permiteVendaViaRfid: false,
		formasDePagamentoRfid: [],
		tabelaDePreco: null,
	}
}

